import {memo} from 'react'
import utils from '@eitje/utils'
import {makeCnVariants} from '../../../../helpers'
import {Dropdown} from '../../../dropdown'
import {Layout} from '../../../layout'
import {AdvancedTableCell} from '../cell'
import './styles/index.less'

const getRowLinks = (row, {rowTo, rowModalLink, rowExtLink}) => ({
	to: rowTo?.(row),
	modalLink: rowModalLink?.(row),
	externalLink: rowExtLink?.(row),
})

export const TableRow = memo(
	({row, rowTo, rowModalLink, rowExtLink, rowDisabled, RowDropdownItems, rowFloating, cells, canExpand, active, isGrouped, ...rest}) => {
		const className = utils.makeCns(makeCnVariants('advanced-table-row', canExpand && 'expandable'), active && 'active')
		const getRowDisabled = rowDisabled
		const disabledByRow = !isGrouped && getRowDisabled?.(row)

		const sharedProps = {className, colorSet: true, height: 32, gap: 0}
		const children = cells.map((c, i) => <AdvancedTableCell {...rest} index={i} row={row} cell={c} getRowDisabled={getRowDisabled} />)

		// a grouped row should open/ close the group on click
		if (isGrouped)
			return (
				<Layout key={row.id} {...sharedProps} onClick={row.getToggleExpandedHandler()}>
					{children}
				</Layout>
			)

		// a non grouped row can be a link, a modal link, an external link or a floating component
		const links = getRowLinks(row, {rowTo, rowModalLink, rowExtLink})

		const content = (
			<Layout key={row.id} {...sharedProps} {...links} disabled={disabledByRow}>
				{children}
			</Layout>
		)

		if (RowDropdownItems)
			return (
				<Dropdown trigger={content} openAtCursorPosition="x">
					<RowDropdownItems row={row} />
				</Dropdown>
			)

		if (rowFloating) {
			const FloatingComponent = rowFloating(row)
			if (FloatingComponent) return <FloatingComponent trigger={content} />
		}

		return content
	},
)
